import React from "react";
import { Main } from "../components/sections/addProduct/Main";

export const AddProduct = () => {
  return <Main />;
};
